import { createActions } from 'redux-actions'

export const INIT_PROFILE_INFO = "INIT_PROFILE_INFO";

export const REQUEST_PROFILE_START = "REQUEST_PROFILE_START";
export const REQUEST_PROFILE_SUCCESS = "REQUEST_PROFILE_SUCCESS";
export const REQUEST_PROFILE_FAIL = "REQUEST_PROFILE_FAIL";

export const {

  initProfileInfo,
  requestProfileStart,
  requestProfileSuccess,
  requestProfileFail,

} = createActions({

  [INIT_PROFILE_INFO]: (req) => ({ req }),

  [REQUEST_PROFILE_START]: (req) => ({ ...req }),
  [REQUEST_PROFILE_SUCCESS]: (res) => ({ res }),
  [REQUEST_PROFILE_FAIL]: (res) => ({ res }),

})


